import { CSSProperties } from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

import { Container } from "./styles";

type NewChatProps = {
  title: string;
  type: string;
  onOpen?: () => void;
  loading?: boolean;
  style?: CSSProperties;
};

const NewChatButton: React.FC<NewChatProps> = ({ title, style, loading }) => (
  <Container style={style}>
    {loading ? <FontAwesomeIcon icon={faSpinner} spin /> : title}
  </Container>
);

export default NewChatButton;
